import { gql } from '@apollo/client';

// ===== Analytics catalogs =====
// `analyticsCatalog` drives the workflow editor: entities to read from, chart
// types to draw and `nodeTypes`, the description of every node the palette,
// the canvas and the inspector render. Node metadata therefore never drifts
// from the server implementation.

export const ANALYTICS_CATALOG = gql`
  query AnalyticsCatalog {
    analyticsCatalog {
      entities {
        key
        label
      }
      chartTypes {
        key
        label
      }
      nodeTypes
    }
  }
`;

export const ANALYTICS_ENTITY_CATALOG = gql`
  query AnalyticsEntityCatalog($entity: String!) {
    analyticsEntityCatalog(entity: $entity) {
      entity
      fields {
        key
        baseKey
        label
        fullLabel
        kind
        options {
          value
          label
        }
        filterable
      }
      joins {
        key
        label
        kind
        description
      }
    }
  }
`;

export const ANALYTICS_JOIN_FIELDS = gql`
  query AnalyticsJoinFields($entity: String!, $join: String!) {
    analyticsJoinFields(entity: $entity, join: $join) {
      key
      baseKey
      label
      fullLabel
      kind
      options {
        value
        label
      }
      filterable
    }
  }
`;
